import { Theme } from '@mui/material';

export const MAX_TEXT_LENGTH_2000 = 2000;
export const MAX_UPLOAD_SIZE = 52428800;

export const inputErrorStyles = {
  [`& .MuiOutlinedInput-notchedOutline`]: {
    border: (theme: Theme) => `1px solid ${theme.palette.primary.contrastText}`,
    boxShadow: `0 0 2px 0px rgba(233, 44, 44, 0.15)`,
  },
};
